import { Config } from '@flowwai-frontend/shared/constants'
import { useCustomT } from '@flowwai-frontend/shared/common-components'

import { ClientConfigType, ClientType } from './types'
import {
   getApMaudConfig,
   getFlowwConfig,
   getMaudAdminConfig,
   getMaudConfig,
   getOfficerPortalAdminConfig
} from './utils'

const useClientConfig = (): ClientConfigType => {
   const clientEnum: ClientType = Config.APP_CLIENT_ENUM

   const t = useCustomT('client:appMode')

   switch (clientEnum) {
      case 'FLOWW':
         return getFlowwConfig(t)
      case 'MA&UD':
      case 'MA&UD_ADMIN':
         return getMaudConfig(t)
      case 'AP_MA&UD':
         return getApMaudConfig(t)
      default:
         return getFlowwConfig(t)
   }
}

export default useClientConfig
